import React from 'react';
import Icon from './Icon';

const GlobeIcon = (props) => (
    <Icon {...props}>
        <path
            d="M17.5 12A5.5 5.5 0 1 1 6.5 12A5.5 5.5 0 0 1 17.5 12M4 20C7 23 23 7 20 4C18.5 2.5 15.5 4.5 14 6.7M6.7 14C4.5 15.5 2.5 18.5 4 20"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default GlobeIcon;